import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { queryKeys } from '@/app/queries/query-keys';
import { useFlashMessage } from '@/app/flash-messages';
import { ApiError, uploadTemplate } from '@/app/api/manage-portfolios';
import { PaginationQueryParams } from '@/app/api';

export const useAllPortfolios = ({ page }: PaginationQueryParams) => {
	return useQuery({
		...queryKeys.manage_portfolios.portfolios({ page, size: 10 }),
		placeholderData: keepPreviousData,
	});
};

export const useUploadTemplatePortfolios = () => {
	const queryClient = useQueryClient();
	const { dispatch } = useFlashMessage();

	return useMutation({
		mutationFn: (formData: FormData) => {
			return uploadTemplate(formData);
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({
				queryKey: queryKeys.manage_portfolios._def,
			});
			dispatch({
				type: 'success',
				content: 'CSV template successfully updated',
			});
		},
		onError: (error: AxiosError<ApiError>) => {
			const { statusCode, message } = error.response?.data || {};
			if (statusCode === 400) {
				dispatch({ type: 'error', content: message });
			}
		},
	});
};
